import enUs from './en-US'
import ptBr from './pt-BR'

export default {
  'en-US': { translation: { ...enUs } },
  'pt-BR': { translation: { ...ptBr } },
}
